export default string => string.replace(/\D/g, '');
